import { FC, HTMLAttributes } from 'react'
import Link from 'next/link'
import { paths } from '@router/paths'
import Image from 'next/image'

type LogoProps = HTMLAttributes<HTMLImageElement> & {
  landingPage?: boolean
  headerOpacity?: number
}

export const Logo: FC<LogoProps> = ({
  className,
  landingPage = false,
  headerOpacity,
  ...props
}) => {
  const whiteLogoSrc = '/images/wlthLogoWhite.webp'
  const purpleLogoSrc = '/images/wlth/logo/wlth-logo-purple.webp'

  // When headerOpacity is 0, white logo is fully visible (opacity 1), purple is hidden (opacity 0)
  // When headerOpacity is 1, white logo is hidden (opacity 0), purple is fully visible (opacity 1)
  const whiteLogoOpacity =
    landingPage && headerOpacity !== undefined ? 1 - headerOpacity : 0
  const purpleLogoOpacity = landingPage && headerOpacity !== undefined ? headerOpacity : 1

  return (
    <Link
      href={paths?.root || '#'}
      className={`relative inline-block min-w-[90px] w-[120px] ${className}`}
      aria-label="WLTH - Go to homepage"
    >
      <Image
        src={whiteLogoSrc}
        alt="WLTH logo"
        width={120}
        height={23}
        className="w-full h-auto"
        style={{
          opacity: whiteLogoOpacity,
          transition: 'opacity 0.3s ease-in-out',
        }}
        {...props}
      />
      <Image
        src={purpleLogoSrc}
        alt="WLTH logo"
        width={120}
        height={23}
        className="absolute top-0 left-0 w-full h-auto"
        style={{
          opacity: purpleLogoOpacity,
          transition: 'opacity 0.3s ease-in-out',
        }}
      />
    </Link>
  )
}
